import { ISkid } from "../interfaces/skid.interface";
import { Flowmeter } from "./flowmeter.model";
import { Gateway } from "./gateway.model";
import { Pump } from "./pump.model";

export class Skid implements ISkid {
    skidId: string;
    skidName: string;
    gatewayId: string;
    flowmeterId: string;
    pumpId: string;
    exatmclasse: string;
    exatmregulation: string;

    pump?: Pump;
    gateway?: Gateway;
    flowmeter?: Flowmeter;

    constructor(skid: ISkid) {
        Object.keys(skid).map(key => this[key] = skid[key]);
    }

    setEquipments(params: SetSkidEquipmentsParams) {
        this.pump = params.pumps.find(pump => pump.pumpId === this.pumpId);
        this.gateway = params.gateways.find(gateway => gateway.gatewayId === this.gatewayId);
        this.flowmeter = params.flowmeters.find(flowmeter => flowmeter.flowmeterId === this.flowmeterId);
    }

    get hasPump(): boolean {
        return this.pump && !(this.pump.isNoPump);
    }

    get pumpName(): string | undefined {
        return this.pump ? this.pump.pumpName : null;
    }

    get pumpFlowrateRange(): string | undefined {
        return this.pump ?
                `${this.pump.pumpMinFlowrate} - ${this.pump.pumpMaxFlowRate}` :
                null;
    }

    get pumpMinFlowrate(): number | undefined {
        return this.pump ? this.pump.pumpMinFlowrate : null;
    }

    get pumpMaxFlowrate(): number | undefined {
        return this.pump ? this.pump.pumpMaxFlowRate : null;
    }

    get pumpMaxPressure(): number | undefined {
        return this.pump ? this.pump.pumpMaxPressure : null;
    }

    get pumpmodelSupplier(): string | undefined {
        return this.pump ? this.pump.pumpmodelSupplier : null;
    }

    get pumpmodelName(): string | undefined {
        return this.pump ? this.pump.pumpmodelName : null;
    }

    get hasGateway(): boolean {
        return this.gateway && !(this.gateway.isNoGateway);
    }

    get gatewayName(): string | undefined {
        return this.gateway ? this.gateway.gatewayName : null;
    }

    get hasFlowmeter(): boolean {
        return this.flowmeter && !(this.flowmeter.isNoFlowmeter);
    }

    get flowmeterName(): string | undefined {
        return this.flowmeter ? this.flowmeter.flowmeterName : null;
    }

    get fieldprotocolName(): string | undefined {
        return this.flowmeter ? this.flowmeter.fieldprotocolName : null;
    }
}

export interface SetSkidEquipmentsParams {
    pumps: Pump[];
    gateways: Gateway[];
    flowmeters: Flowmeter[];
  }